import React from 'react';

const ResponseEmptyMessageMessage = () => <div className={'error-message-box'}>
	<i className="fas fa-exclamation-triangle"></i> Looks like your list is empty.</div>;

export default ResponseEmptyMessageMessage;
